<template>
  <div class="logsig_1 between">
    <div class="typeitem">
      <div class="regtx"><img src="~assets/user/gryhreg.png" /></div>
      <div class="regtit mt30">公众用户</div>
      <div class="regdes mt40">
        注册公众会员后，您可免费向律师咨询法
        律问题、免费发布咨询、布案件委托、查 找法律条文…
      </div>
      <div class="regbtn" @click="tojump(1)">点击注册</div>
    </div>


    <div class="typeitem">
      <div class="regtx"><img src="~assets/user/lsyhreg.png" /></div>
      <div class="regtit mt30">律师用户</div>
      <div class="regdes mt40">
        注册律师会员后，您可免费发布文章、查
        看案件委托、查找法律条文、获得免费个 人主页…
      </div>
      <div class="regbtn" @click="tojump(2)">点击注册</div>
    </div>


    <div class="typeitem">
      <div class="regtx"><img src="~assets/user/lsuoreg.png" /></div>
      <div class="regtit mt30">律所用户</div>
      <div class="regdes mt40">
        注册律所会员后，可免费发布文章照片、
        查看案件委托、查找法律条文、获得免费 律所主页…
      </div>
      <div class="regbtn" >暂未开放注册</div>
    </div>

    
  </div>
</template>

<script>
export default {
  beforeMount(){
    this.$parent._data.currentactep = 1
  },
  methods: {
    tojump(index) {
      let url = '/log/logsig/logsig_2_'+index
      console.log(url);
      this.$router.push({
        path:url
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.logsig_1 {
  .typeitem {
    width: 300px;
    background: #ffffff;
    padding: 35px 24px 50px;
    box-shadow: 1px 1px 9px 0px rgba(0, 0, 0, 0.11);
    text-align: center;
    .regtx {
      img {
        width: 151px;
        height: 151px;
      }
    }
    .regtit {
      font-size: 24px;
      color: #333333;
    }
    .regdes {
      font-size: 14px;
      color: #333333;
      line-height: 20px;
      text-align: left;
    }
    .regbtn {
      cursor: pointer;
      width: 250px;
      height: 44px;
      line-height: 44px;
      text-align: center;
      margin: 30px auto 0;
      background: #0057ff;
      border-radius: 3px;
      font-size: 18px;
      color: #ffffff;
      &:hover {
        background: #6398ff;
      }
    }
  }
}
</style>